module.exports = __webpack_public_path__ + "img/phone_bg.1698e58e.png";